import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddressBookDto, BankDto, IndividualAcreagesDto, LessorInfoDto, LessorRepresentativeDto, LessorRepTypeDto, LessorStakeholderDto, LossOfUseItemsDto, MeasureDto, TerrainDto } from '@cradua/data';

 interface ILessor {
   lessorInfos: LessorInfoDto[],
   lessorRepresentatives: LessorRepresentativeDto[],
   lessorStakeholders: LessorStakeholderDto[],
   addressBooks: AddressBookDto[],
   lessorRepTypes: LessorRepTypeDto[],
   individualAcreages: IndividualAcreagesDto[],
   lossOfUseItems: LossOfUseItemsDto[],
   banks: BankDto[],
   terrains: TerrainDto[],
   measures: MeasureDto[],
   type: string;
 }

 export interface Row {
  id: string,
  text1: string,
  text2: string,
  children?: Row[]
}

export const ROWS: Row[] = [
    {
      id: "1",
      text1: "text 1.1",
      text2: "text 1.2"
    },
    {
      id: "2",
      text1: "text 2.1",
      text2: "text 2.2",
      children: [
        {
          id: "2.1",
          text1: "text 2.1.1",
          text2: "text 2.1.2",
        },
        {
          id: "2.2",
          text1: "text 2.2.1",
          text2: "text 2.2.2",
        },
      ]
    },
    {
      id: "3",
      text1: "text 3.1",
      text2: "text 3.2"
    },
    {
      id: "4",
      text1: "text 4.1",
      text2: "text 4.2",
      children: [
        {
          id: "4.1",
          text1: "text 4.1.1",
          text2: "text 4.1.2",
        },
        {
          id: "4.2",
          text1: "text 4.2.1",
          text2: "text 4.2.2",
        },
      ]
    },
  ];

@Component({
  selector: 'app-lessor-modal',
  templateUrl: './lessor-modal.component.html',
  styleUrls: ['./lessor-modal.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class LessorModalComponent implements OnInit {


  listView = false;
  gridView = true;
  transformedLessorRepresentative= [];
  transformedLessorStakeholders= [];
  panelOpenState = false;
  transformedLessorInfos: any[];

  expanded: {[key: string]: boolean} = {};
  rows = ROWS;



  constructor(
    public dialogRef: MatDialogRef<LessorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: ILessor,
  ) { }

  ngOnInit(): void {
    if(this.modalData?.lessorRepresentatives && this.modalData?.type === 'representative') {
      this.filterRepresentative(this.modalData?.lessorRepresentatives);
    } else if(this.modalData?.lessorStakeholders && this.modalData?.type === 'stakeholder') {
      this.filterStakeholder(this.modalData?.lessorStakeholders);
    } else if(this.modalData?.lessorInfos && this.modalData?.type === 'lessorInfo') {
      this.transformLessorInfo(this.modalData?.lessorInfos);
    }
  }

  isRowClickable(rowIndex: number): boolean {
    return this.transformedLessorInfos[rowIndex]?.children && this.transformedLessorInfos[rowIndex]?.children?.length > 0
  }

  getAddressBook(id: string) {
    const foundAddressBook = this.modalData.addressBooks.find(item => item.id === id);
    return foundAddressBook ? foundAddressBook : {};
  }

  transformLessorInfo(lessorInfos: LessorInfoDto[]) {
    this.transformedLessorInfos = lessorInfos.map(lessor => ({
      ...lessor,
      children: this.getLessorAcreages(lessor?.id),
    }));
  }

  getTerrainName(id: string) {
    const found = this.modalData?.terrains.find(item => item.id === id);
    return found ? found.TerrainName : '';
  }

  getMeasureName(id: string) {
    const found = this.modalData?.measures.find(item => item.id === id);
    return found ? found.MeasureName : '';
  }

  getLessorAcreages(id: string): IndividualAcreagesDto[] {
    return this.modalData?.individualAcreages.filter(acreage => acreage?.LessorsId === id) || [];
  }


  filterRepresentative(lessorRepresentatives: LessorRepresentativeDto[]) {

       this.transformedLessorRepresentative = lessorRepresentatives.map(item => {
        return {
          addressBook: {
            BankName: this.getBankName(this.getAddressBook(item.AddressBookId)['BankId']),
            ...this.getAddressBook(item.AddressBookId)
          },
          ...item
        }
     });

  }

  filterStakeholder(lessorStakeholders: LessorStakeholderDto[]) {

       this.transformedLessorStakeholders = lessorStakeholders.map(item => {
        return {
          addressBook: {
            BankName: this.getBankName(this.getAddressBook(item.AddressBookId)['BankId']),
            ...this.getAddressBook(item.AddressBookId)
          },
          ...item
        }
     });

  }


  getSurveyArea(addr: LessorInfoDto) {
    if(this.modalData?.individualAcreages != null && this.modalData?.individualAcreages.length) {
      const filteredIndividualAcreages = this.modalData?.individualAcreages.filter(data => data.LessorsId === addr.id && data.AddressBookId === addr.AddressBookId);
      return filteredIndividualAcreages.length ?
      filteredIndividualAcreages.map((item) => item.NetArea)
      .reduce((prev, next) => prev + next) : 0;
    } else {
      return 0;
    }
  }

  getLessorRepTypeName(id: string) {
    const found = this.modalData.lessorRepTypes.find(item => item.id === id);
    return found ? found.LessorRepName : '';
  }

  getBankName(id: string) {
    const found = this.modalData.banks.find(item => item.id === id);
    return found ? found.BankName : '';
  }

  onSubmit(representative, type) {
    const data = {
      representative,
      type,
    }
    this.dialogRef.close(data);
  }

  onSubmitLessor(lessorInfo, acreage, type) {
    const data = {
      lessorInfo,
      acreage,
      type,
    }
    this.dialogRef.close(data);
  }

  onSubmitLossOfUseItems(lossOfUse: LossOfUseItemsDto) {
    this.dialogRef.close(lossOfUse);
  }

}
